module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"current_reward":"현재 적립금(예상)","remaining_reward":"추가 적립가능 금액"}}')
  delete Component.options._Ctor
}
